import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";
import UtilHelper from "../../utils/UtilHelper";
import "./payment.css";
interface PaymentSummaryTotalAmountProps {
  amount: string
  label: string
}

export default function PaymentSummaryTotalAmount({ amount, label}: PaymentSummaryTotalAmountProps) {
  const parsedAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
  // bug/amount-format-fix: CurrencyFormat()/formatCurrency() have no NaN guard of their own --
  // an empty/non-numeric amount would otherwise render "NaN" instead of "$0.00".
  const numericAmount = isNaN(parsedAmount) ? 0 : parsedAmount;

  // bug/amount-format-fix: the hidden tooltip content stays the exact full amount, so hovering
  // an abbreviated value still reveals the precise figure, same as elsewhere in the app.
  const displayAmount = UtilHelper.formatCurrencyFullUnder10K(numericAmount, false);

  return (
    <div className="payment-summary-container">
      <div className="payment-row">
        <span className="payment-label">{label}</span>
        <div className="dotted-line"></div>
        <CurrencyTooltip
          content={UtilHelper.CurrencyFormat(numericAmount, false)}
          formatted={displayAmount}
        >
          <span className="payment-amount">{displayAmount}</span>
        </CurrencyTooltip>
      </div>
    </div>
  )
}